import { render, staticRenderFns } from "./DashboardProvider.vue?vue&type=template&id=7d958240&scoped=true&"
import script from "./DashboardProvider.vue?vue&type=script&lang=ts&"
export * from "./DashboardProvider.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d958240",
  null
  
)

export default component.exports